import React from "react";
import Scrollspy from "react-scrollspy";

const ScrollSpy = () => {
  return (
    <Scrollspy
      items={["about", "features", "team", "services", "contact"]}
      currentClassName="active"
      offset={-50}
      onUpdate={(el) => {}}
      style={{
        fontWeight: 300,
      }}
      className="flex-lg-column nav nav-pills default-pills menu-scrollspy"
    >
      <li className="nav-item">
        <a className="nav-link" href="#about">
          About
        </a>
      </li>
      <li className="nav-item">
        <a className="nav-link" href="#features">
          Features
        </a>
      </li>
      <li className="nav-item">
        <a className="nav-link" href="#team">
          Team
        </a>
      </li>
      <li className="nav-item">
        <a className="nav-link" href="#services">
          Services
        </a>
      </li>
      <li className="nav-item">
        <a className="nav-link" href="#contact">
          Contact
        </a>
      </li>
    </Scrollspy>
  );
};

export default ScrollSpy;
